import * as React from "react";
const SvgFiRrExpenseBill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-expense-bill_svg__a)">
      <path
        fill="#062147"
        d="M7 12.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 7 12.5M5.5 18a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 18m13 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 18.5 18m0-7a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 18.5 11m5.5 2v6c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5v-6c0-2.757 2.243-5 5-5h5.998l-.01-5.066-1.283 1.275a.997.997 0 0 1-1.414-.004 1 1 0 0 1 .004-1.414l2.19-2.177a2.105 2.105 0 0 1 2.972.002l2.238 2.165a1 1 0 0 1-1.391 1.437l-1.316-1.273.01 5.055H19c2.757 0 5 2.243 5 5m-2 0c0-1.654-1.346-3-3-3H5c-1.654 0-3 1.346-3 3v6c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3zm-6 3c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4m-2 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-expense-bill_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrExpenseBill;
